(function () {
  // Words that mark an item as "issue/defective"
  const ISSUE_WORDS = [
    'functional issue',
    'faulty',
    'defective',
    'for parts',
    'parts only',
    'dead',
    'broken',
    'cracked',
    'not working',
    'no power',
    'for scrap',
    'ipad mini 3'
  ];

  const PREFERRED_WORDS = [
    'good condition',
    'refurbished',
    'unboxed'
  ];

  function isIssueTitle(title) {
    if (!title) return false;
    const t = title.toLowerCase();
    return ISSUE_WORDS.some((w) => t.includes(w));
  }

  function isPreferredTitle(title) {
    if (!title) return false;
    const t = title.toLowerCase();
    return PREFERRED_WORDS.some((w) => t.includes(w));
  }

  function sanitizeAndSort(list) {
    if (!list) return;

    // Collect <li> items
    const items = Array.from(list.children);

    // Read search term from active input
    const input = document.querySelector('input[name="q"]:focus, input[name="q"]');
    const term = (input && input.value ? input.value : '').toLowerCase().trim();

    // Prioritize exact query matches first (preferred grade, then standard),
    // followed by loose matches (preferred grade, then standard), and issues last.
    const exactPreferred = [];
    const exactStandard = [];
    const loosePreferred = [];
    const looseStandard = [];
    const issue = [];

    items.forEach((li) => {
      const heading = li.querySelector('.predictive-search__item-heading');
      const title = heading ? heading.textContent.trim().toLowerCase() : '';
      const isIssue = isIssueTitle(title);
      const isPreferred = isPreferredTitle(title);
      const isExact = term && title.includes(term);

      if (isIssue) {
        issue.push(li);
      } else if (isExact && isPreferred) {
        exactPreferred.push(li);
      } else if (isExact) {
        exactStandard.push(li);
      } else if (isPreferred) {
        loosePreferred.push(li);
      } else {
        looseStandard.push(li);
      }
    });

    // Cap to 12 (change if you prefer)
    const MAX = 12;
    const trimmed = exactPreferred.concat(exactStandard, loosePreferred, looseStandard, issue).slice(0, MAX);

    // Paint
    list.replaceChildren(...trimmed);
  }

  // Run once now (in case markup is already on page)
  function runOnce() {
    const list = document.getElementById('predictive-search-results-products-list');
    if (list) sanitizeAndSort(list);
  }

  // Observe for changes whenever predictive search re-renders
  const observer = new MutationObserver(() => {
    // Delay a tick so inner HTML settles
    setTimeout(runOnce, 0);
  });

  function startObserving() {
    const wrapper = document.getElementById('predictive-search-results');
    if (!wrapper) return;
    observer.observe(wrapper, { childList: true, subtree: true });
  }

  // Kick off on DOM ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => {
      startObserving();
      runOnce();
    });
  } else {
    startObserving();
    runOnce();
  }
})();
